/* eslint-disable-file */
import * as Sentry from '@sentry/browser'
import configment from '@adc/configment'
import logger from '@adc/logger'

const sentryLogger = logger.forModule('sentry')
const environment = configment.get('ENV', 'ci')
const sentryDsn = configment.get('SENTRY_DSN', '')
const sentryEnabledForBrowser = configment.get(
  'ENABLE_SENTRY_BROWSER_SDK',
  false
)

const isValidSentryException = event => {
  if (typeof event !== 'object' || event === null) return false
  return event instanceof Error || Boolean(event.exception)
}

if (sentryEnabledForBrowser && sentryDsn && environment !== 'dev') {
  sentryLogger.info('Sentry enabled.')

  Sentry.init({
    dsn: configment.get('SENTRY_DSN'),
    release: configment.get('VERSION_IDENTIFIER'),
    environment: environment,
    blacklistUrls: [
      // Done with you.. you go to the naughty step hotjar
      //
      // Example: https://sentry.io/organizations/auctioncorp/issues/1295212634/?environment=prod&project=1722583&query=is%3Aunresolved
      /script\.hotjar\.com/i,
      /in\.hotjar\.com/i,
      /vc\.hotjar\.io/i,

      // What are you even doing here?!
      //
      // Example: https://sentry.io/organizations/auctioncorp/issues/1296754861/?project=1722583
      /analytics\.yahoo\.com/i,

      // I thought we were so supposed to be friends. Not angry, just disappointed. If marketing wants to inject you
      // anywhere, we must end this previously cordial relationship.
      /googletagmanager\.com/i,

      // You blithering idiot, you. You are causing as many errors as we have have users. *sigh* why do we let broken
      // code run on our apps because marketing. Marketing before humans.
      //
      // https://sentry.io/organizations/auctioncorp/issues/1296353611/?environment=prod&project=1722583&query=is%3Aunresolved
      /doubleclick\.net/,
    ],
    beforeSend: function (exception) {
      // NOTE: We used to try and capture errors that were not true error objects, but that was always prone to false
      // positives. Simplifying it just to check for valid error instances helps force everyone to throw actual errors
      // instead of other values, and also helps us to reduce error volume in our Sentry org.
      try {
        if (!isValidSentryException(exception)) {
          return null
        }
      } catch (e) {
        sentryLogger.error('Local error in Sentry processing: ' + e)
      }

      // TODO: If has a special `metadata` key on the error, send that stuff as tags along with the error

      return exception
    },
  })

  Sentry.configureScope(function configureScope(scope) {
    // We can be certain this will always be set, since foundation sets it for applications that render
    scope.setTag('application', configment.get('APP_NAME'))
    scope.setTag(
      'execution_environment',
      configment.get('EXECUTION_ENVIRONMENT')
    )
  })
} else {
  sentryLogger.info('Sentry disabled.')
}
